<template>
  <md-card>
    <md-card-header v-if="title || $slots['title'] || $slots['actions']">
      <div class="md-subhead">
        <slot name="title">{{ title }} {{ index === null ? '' : index+1 }}</slot>
      </div>
      <div class="header-actions">
        <slot name="actions" />
      </div>
    </md-card-header>
    <!-- <div class="md-layout">
      <slot />
    </div> -->
    <slot />
  </md-card>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: null,
    },
  },
  methods: {
    
  }
};
</script>

<style scoped lang="scss">
  @import "@/assets/scss/theme.scss";

  .md-card{
    background: rgba(0, 0, 0, 0.01) !important;
    border: 1px solid rgba(0,0,0,0.1);

    .md-subhead{
      display: flex;
      align-items: center;
    }

    .md-card-header{
      display: flex;
      justify-content: space-between;
      background: rgba(0, 0, 0, 0.03);
      margin-bottom: 8px;
      padding: 4px 16px;
    }

  }

  ::v-deep .header-actions > .md-icon{
    padding: 20px;
  }
</style>